module.exports = __webpack_public_path__ + "static/TrustMarkGovernmentEndorsedLogo-4ef66bac49ed69b0df4b062cb95fa3fd.jpg";